import { Breadcrumbs } from "./Breadcrumbs";
import { MaskLines, FadeIn } from "./Reveal";

export const PageHero = ({ crumbs, eyebrow, lines, intro, children, aside }) => (
  <section className="grain relative overflow-hidden bg-[#13052A] pb-20 pt-36 text-white sm:pt-40" data-testid="page-hero">
    <div className="grid-lines pointer-events-none absolute inset-0 opacity-60" />
    <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#7C3AED]/30 blur-[120px]" />
    <div className="pointer-events-none absolute -bottom-40 left-1/4 h-[360px] w-[360px] rounded-full bg-[#2563EB]/20 blur-[120px]" />
    <div className={`relative mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 ${aside ? "lg:grid-cols-[1.3fr_1fr] lg:items-end" : ""}`}>
      <div>
        {crumbs && <Breadcrumbs crumbs={crumbs} />}
        {eyebrow && <FadeIn><p className="eyebrow text-violet-300"><span className="h-1.5 w-1.5 rounded-full bg-[#60A5FA]" />{eyebrow}</p></FadeIn>}
        <MaskLines lines={lines} testid="page-h1" className="mt-5 max-w-4xl text-4xl font-extrabold leading-[1.02] sm:text-5xl lg:text-6xl" />
        {intro && <FadeIn delay={0.4}><p className="mt-7 max-w-2xl text-base leading-relaxed text-violet-100 md:text-lg">{intro}</p></FadeIn>}
        {children && <FadeIn delay={0.55} className="mt-9 flex flex-wrap gap-3">{children}</FadeIn>}
      </div>
      {aside && <FadeIn delay={0.5}>{aside}</FadeIn>}
    </div>
  </section>
);
